import React from 'react';
import Article from './Article';
import Subheading from './Subheading';
import Graf from './Graf';
import { Paragraph } from 'scy/text';

export default function TermsOfService() {
  return (
    <Article
      title="Terms of Service"
      lastUpdated="July 14, 2017"
      asideTitle="contact"
      asideBody="support@saucey.com"
    >
      <Subheading>I. Agreement to be bound by Contract Terms</Subheading>
      <Graf>
        Please read these Terms of Service (“Terms”) thoroughly. By downloading,
        accessing or using Saucey, Inc.’s mobile application (“the App”),
        website or other products or services (collectively, the “Services”),
        and any information, text, graphics, photos or other materials uploaded,
        downloaded or appearing on the Services (collectively referred to as
        “Content”) you agree to be bound by these Terms. The term “you” or
        “User” shall refer to any person or entity who views, uses, accesses,
        browses or submits any content or material to the App. Your access to
        and use of the Services are conditioned on you accepting and complying
        with the Terms. If you do not agree to be bound by these Terms, then you
        may not use the App, website, other products or Services.
      </Graf>
      <Graf>
        Saucey, Inc. (“Saucey”, “We” or “Us”) may change or modify these Terms
        at any time and in our sole discretion. If we make changes to these
        Terms, we will provide notice of such changes, such as sending a
        notification, posting a notice on the Services or updating the “Last
        Updated” date above. By continuing to use the Services you confirm your
        acceptance of the revised Terms. We encourage you to frequently review
        the Terms to ensure you understand the terms and conditions that apply
        to your use of the Services. If you do not agree to the amended or
        updated Terms, you must stop using the Services and delete your Saucey
        account.
      </Graf>
      <Graf>
        You acknowledge and agree that (i) this Agreement is concluded between
        you and Saucey only, and not Apple, and (ii) Saucey, not Apple, is
        solely responsible for the App, which is sourced through Apple’s App
        Store. Your use of the App must comply with the App Store Terms of
        Service. You further agree that Apple has no obligation whatsoever to
        furnish any maintenance and support services with respect to the App.
      </Graf>
      <Graf>
        By downloading this application, you are voluntarily agreeing to be
        bound by Saucey’s Terms of Service. If you do not understand any portion
        of the Terms, you should not use Saucey’s Services. You further confirm
        that you are 21 years of age or older and you will provide government
        issued photo identification and a physical credit card used to make the
        purchase (if requested) upon delivery, to verify your age and identity.
      </Graf>

      <Subheading>II. Access to Saucey’s Services</Subheading>
      <Graf>
        Saucey grants you a non-transferable, non-exclusive limited license to
        access and make personal use of the Services and the App, subject to the
        Terms (“License”). The License allows you to use the Services for your
        personal, non-commercial use. The License also allows you to download,
        install any Saucey applications related to the Services on a mobile
        device that you own or control for your personal non-commercial use.
        Saucey’s grant of the License does not permit you to duplicate,
        transfer, give access to, copy or distribute any part of the Services in
        any way, or use the Services in any manner not consistent with the
        Terms. Any unauthorized use terminates the License granted by Saucey.
        All rights not expressly granted herein are reserved by Saucey.
      </Graf>

      <Subheading>III. Processing and Delivery of Products</Subheading>
      <Graf>
        Saucey provides a delivery service only, for local liquor stores (the
        “Retailers”), through which all orders and purchases are processed.
        Saucey does not hold a license to sell alcohol, nor is it a licensed
        retailer. At the time you purchase alcoholic beverages or other items
        (“Products”), you are purchasing those items from a licensed retailer,
        and your credit card will be charged by a third party credit card
        processing provider who will transfer and deliver the funds to the
        Retailers.
      </Graf>
      <Graf>
        Neither Saucey, nor any officer, director, employee, shareholder or
        agent of Saucey shall be liable to the User or any third-party for any
        claims relating to the purchase, sale, delivery and/or consumption of
        the alcoholic beverage or any consequences which may result thereof.
      </Graf>
      <Graf>
        By completing an order through the App, you agree that you are 21 years
        of age or older and that you will be present to accept the delivery of
        alcoholic beverages. You agree that you will not be intoxicated when
        receiving delivery of such products. If you are sending a gift, you
        agree that the recipient is an individual 21 years of age or older.
      </Graf>
      <Graf>
        All deliveries including alcoholic beverages must be accepted by the
        account holder, who is capable of proving that he or she is 21 years of
        age or older and can provide a valid form of government issued
        identification at the time of delivery.
      </Graf>
      <Graf>
        If there is no individual who is 21 years of age or older or cannot
        provide valid identification showing that he or she is 21 years of age
        or older, the delivery driver (the “Courier”) will not complete delivery
        of the Products. Additionally, if the Courier is unable to contact you
        or the account holder at the specified delivery address for 5 or more
        minutes, all Products will be removed from the order and returned to the
        Retailers and a $7.99 restocking fee will be charged to User’s credit
        card and the original order balance will be returned to User.
      </Graf>
      <Graf>
        The Courier reserves the right to refuse to deliver Products for any
        reason. This reservation includes, but is not limited to, refusing
        service to individuals who are visibly intoxicated or to specific
        locations for safety reasons. Products cannot and will not be left
        unattended for any reason. Any Retailer reserves the right to not accept
        any order for any reason.
      </Graf>

      <Subheading>IV. App Usage</Subheading>
      <Graf>
        Your use of the App and Services is subject to all applicable local,
        state and federal laws and regulations. It is your responsibility to
        provide the mobile device, wireless service/data plan and software
        needed, in order to install and use the App and Services. You are solely
        responsible for any fee, cost or expense that you may incur, to
        download, install and/or use the App or Services on your mobile device
        or smartphone.
      </Graf>
      <Graf>
        You understand and acknowledge that the App is an electronic platform
        for the purpose of connecting consumers to chosen Retailers to engage in
        the sale, service, delivery and/or transportation delivery of Products.
        All sales of Products are transacted between you and the Partner(s).
        Saucey does not provide or sell alcoholic beverages. No joint venture,
        partnership, employment, or agency relationship exists between Saucey
        and any business or third party as a result of this License or use of
        the App or Services.
      </Graf>

      <Subheading>V. Saucey Premium</Subheading>
      <Graf>
        Saucey Premium is an optional subscription-based membership program that
        offers unlimited delivery without an added delivery fee and a discount
        on pricing throughout the platform for a term-based subscription fee. If
        you choose to sign up for Saucey Premium, we will bill you the
        applicable fee after your free trial period has expired. If you choose
        not to renew Saucey Premium before the trial period has expired, we will
        not charge you. You may choose not to renew your Saucey Premium
        membership at any time from the Account Info page. If you want to cancel
        an active Saucey Premium membership, you can contact us at
        support@sauceyapp.com.
      </Graf>
      <Graf>
        We may change the fee charged for Saucey Premium at any time, but any
        such fee change will not apply to current Saucey Premium members until
        such time as your current membership expires and your membership is
        renewed for another term.
      </Graf>
      <Graf>
        We may change other terms or conditions applicable to Saucey Premium
        from time to time. Any new or renewed Saucey Premium memberships will be
        subject to the terms and conditions active at that time and displayed
        when you sign up for Saucey Premium. We may also make such changes with
        respect to current Saucey Premium memberships. In that case, we will
        provide you with notice by email of the changes and when those changes
        take effect. We will also offer you the ability to cancel your Saucey
        Premium membership and receive a refund of your membership fee on a pro
        rata basis calculated from the end of the month during which you cancel
        the membership.
      </Graf>

      <Subheading>VI. Bartender Booking</Subheading>
      <Graf>
        Bartenders are contracted through a third party provider. Saucey is not
        liable for any incident occurring as a result of booking a bartender.
        Bookings must be made at least 24-hours in advance. Your bartender will
        not bring a bar. Your bartender will not bring garnishes, ice, utensils,
        cups, or napkins. To cancel or reschedule, please email
        booking@saucey.com. You may reschedule up to 48 hours before the start
        of your event at no cost to you. You may cancel for a refund up to 24
        hours before the start of your event. If you cancel within 24 hours of
        the booking you will be charged in full.
      </Graf>

      <Subheading>VII. Buying and Shipping Alcoholic Beverages</Subheading>
      <Graf>
        All alcohol sales are made by Liquorama Fine Wines & Spirits, a licensed
        alcohol retailer located in Upland, California. Title to, and ownership
        of, all alcoholic beverages passes from seller to buyer in California,
        and buyer takes all responsibility for the alcohol being transported
        from California to the buyer’s selected destination. By placing an
        order, buyer authorizes seller to act on buyer’s behalf in arranging for
        transportation of the alcohol at the buyer’s direction. Alternatively,
        buyer may choose to pick up the alcohol at seller’s location, or make
        independent delivery arrangements. Sales tax will be applied based on
        the seller’s location. Seller makes no representation as to the legal
        rights of anyone to deliver or import alcoholic beverages or other goods
        into any state. Buyer is solely responsible for the transport of alcohol
        and other goods purchased and for determining the legality and the
        tax/duty consequences of having the alcohol and other goods delivered to
        the applicable destination.
      </Graf>
      <Graf>
        Alcohol prices do not include shipping/handling charges, the cost of
        which varies depending on destination, number of bottles ordered and
        choice of delivery options.
      </Graf>
      <Graf>
        No shipments will be made to PO Boxes, APO/FPO addresses, or
        internationally. Shipping fees are not refundable under any
        circumstances.
      </Graf>
      <Graf>
        There is an additional charge to re-route orders already in transit.
      </Graf>
      <Graf>
        Some items are removed from their original packaging and placed in
        protective shipping containers to ensure safe delivery.
      </Graf>

      <Subheading>
        VIII. Ability to Accept Terms of Service and User Conduct
      </Subheading>
      <Graf>
        You affirm that you are 21 years of age or older and are fully able and
        competent to enter into the terms, conditions, obligations,
        affirmations, representations, and warranties set forth in these Terms,
        and to abide by and comply with these Terms. You further represent and
        warrant that you are not located in a country that is subject to a U.S.
        Government embargo, or that has been designated by the U.S. Government
        as a “terrorist-supporting” country, and that you are not listed on any
        U.S. Government list of prohibited or restricted parties.
      </Graf>
      <Graf>You also agree that:</Graf>
      <Paragraph tag="ul">
        <li>you are fully able and legally competent to agree to the Terms;</li>
        <li>
          you will not impair or harm the App or Services or attempt to gain
          unauthorized access to the App in any way;
        </li>
        <li>
          your use of the App and/or Services is subject to all applicable
          local, state and federal laws and regulations and you will not use the
          App for any illegal purposes;
        </li>
        <li>
          you will not to use the App to purchase alcohol unless you and the
          alcohol recipient are 21 years old or older and can provide a valid
          form of government issued identification and physical credit card (if
          requested), which verifies your age, at the time of delivery;
        </li>
        <li>
          Saucey reserves the right to prosecute, to the fullest extent of the
          law: any attempt by you to misconstrue your age, either directly or
          indirectly; or any attempt to use Saucey’s Services to provide alcohol
          to an individual who is under the age of 21;
        </li>
        <li>
          you will not access the App or Services, using the account information
          of someone other than you; without the express consent of the account
          holder;
        </li>
        <li>
          you will not impersonate or misrepresent your affiliation with any
          person or entity;
        </li>
        <li>
          you will not abuse the Service by creating multiple or duplicate
          accounts or exploiting any errors in the app or system to gain access
          to unintended benefits (abusing promo codes, referral programs, etc)
        </li>
        <li>
          you will not use the App to engage in commercial activities, aside
          from those sanctioned by Saucey;
        </li>
        <li>you will not copy or distribute any content from the App;</li>
        <li>
          you will not attempt to decipher, decompile, disassemble, or reverse
          engineer any of the software used to provide the Site, App, Services,
          or any of their Content;
        </li>
        <li>
          you will not interfere with, or attempt to interfere with, the access
          of any user, host, or network, including, without limitation, sending
          a virus, overloading, flooding, spamming, or mail-bombing the Site,
          App, or Services;
        </li>
        <li>
          you will not resell the use of the App or Services to a third party;
        </li>
        <li>
          you will not Encourage or enable any other individual to do any of the
          foregoing;
        </li>
        <li>
          it is your responsibility to keep your account password and any
          identifying information, confidential;
        </li>
        <li>any Partner may decline your delivery request for any reason</li>
      </Paragraph>
      <Graf>
        Saucey shall not be liable for any loss or damage arising from the
        User’s failure to comply with the Terms or applicable laws. The Terms
        will continue to apply until you or Saucey terminates them as follows:
        (a) You discontinue using the Services; or (b) Saucey may suspend or
        terminate your accounts or cease providing you with all or part of the
        Services at any time for any reason.
      </Graf>

      <Subheading>IX. Intellectual Property</Subheading>
      <Subheading tag="h3">A. Trademarks</Subheading>
      <Graf>
        All Saucey logos, titles, characters and graphics are service marks,
        trademarks and/or trade dress of Saucey and may not be used by you for
        any reason other than as expressly permitted by Saucey. All other
        trademarks, not owned by Saucey, that appear on the App are the property
        of their respective owners and you shall not obtain any ownership rights
        in such marks, logos or names by your use of the App.
      </Graf>

      <Subheading tag="h3">B. Proprietary Rights</Subheading>
      <Graf>
        You acknowledge and agree that the App contains proprietary information
        and content that is intellectual property, which is protected by the law
        and may not be used except as provided for by Saucey.
      </Graf>
      <Graf>
        You acknowledge that monetary compensation for the consequences of
        unauthorized commercial use or republication of content or information
        from the App may not be sufficient or appropriate and in that event,
        Saucey will be entitled to temporary and permanent injunctive relief to
        prohibit such use.
      </Graf>

      <Subheading tag="h3">C. Copyright Infringement Policy</Subheading>
      <Graf>
        Saucey abides by and respects copyright law and expects the same from
        its Users. We reserve the right to terminate Users who are infringing or
        are alleged to be infringing on the rights of copyright holders, at our
        sole discretion, and without liability to you. In appropriate
        circumstances, Saucey will also terminate a User’s account if the user
        is determined to be a repeat infringer.
      </Graf>
      <Graf>
        If you believe that your Content has been used in such a way that
        violates or infringes on your copyrighted Content, you may notify us by
        contacting our designated agent:
      </Graf>
      <Paragraph tag="address">
        Saucey, Inc.
        <br />
        c/o Lowenstein Sandler
        <br />
        390 Lytton Avenue
        <br />
        Palo Alto, California 94301
        <br />
        650.433.5800
        <br />
      </Paragraph>

      <Subheading>X. Fees</Subheading>
      <Graf>
        Any fees that Saucey may charge you for the App or Services, are due
        immediately and are non-refundable. Saucey, at its sole discretion, may
        make promotional offers with different features and different rates to
        any users. These promotional offers, unless made to you, shall have no
        bearing whatsoever on your offer or contract. Saucey may change the fees
        for the Services or the App without notice.
      </Graf>

      <Subheading>XI. Termination and Modifications</Subheading>
      <Graf>
        Saucey reserves the right to modify, suspend, or discontinue at any
        time, without notice, the App and/or Services offered on or through the
        App (or any part thereof), including but not limited to the App’s
        features, look and feel, and functional elements and related services.
      </Graf>
      <Graf>
        Furthermore, Saucey reserves the right to modify the Terms at any time.
        Modifications are effective upon your first access of the App or use of
        Services after the “Last Updated” date at the beginning of these Terms.
        Your use of the App and/or Services will be deemed as your acceptance of
        the modified Terms. If you choose not to accept the modified Terms, then
        you should uninstall the App and discontinue any use of the Services.
      </Graf>
      <Graf>
        The Terms and/or the License are effective until either the date you
        uninstall the App or you fail to comply with any term of these Terms or
        the License or Saucey terminates this License, whichever is earliest.
        Upon termination, you will discontinue all use of the App and Services.
        Termination does not limit or waive any of Saucey’s rights or remedies
        at law or in equity.
      </Graf>

      <Subheading>XII. Disclaimers and Limitations of Liability</Subheading>
      <Graf>
        This section intends to limit the liability of Saucey, its subsidiaries,
        affiliates, related companies, officers, directors, employees, agents,
        representatives, partners, and licensors (collectively, the “Saucey
        Entities”). The provision below only applies up to the maximum extent
        permitted under applicable law. Some jurisdictions do not allow the
        disclaimer of implied warranties or the limitation of liability in
        contracts, and as a result the contents of this section may not apply to
        you. Nothing in this section is intended to limit any rights you may
        have which may not be lawfully limited.
      </Graf>
      <Graf>
        YOU AGREE THAT YOUR USE OF THE SERVICES OFFERED BY SAUCEY SHALL BE AT
        YOUR SOLE RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE
        SAUCEY ENTITIES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
        SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR
        REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA,
        USE, GOOD-WILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (i) YOUR
        ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICES; (ii) ANY
        CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE SERVICES, INCLUDING WITHOUT
        LIMITATION, ANY DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF OTHER USERS
        OR THIRD PARTIES; (iii) ANY CONTENT OBTAINED FROM THE SERVICES; OR (iv)
        UNAUTHORIZED ACCESS, USE OR ALTERATION OF YOUR TRANSMISSIONS OR CONTENT.
      </Graf>
      <Graf>
        IN NO EVENT SHALL THE AGGREGATE LIABILITY OF THE SAUCEY ENTITIES EXCEED
        THE GREATER OF FIFTY U.S. DOLLARS (U.S. $50.00) OR THE AMOUNT YOU PAID
        SAUCEY, IF ANY, IN THE PAST SIX MONTHS FOR THE SERVICES GIVING RISE TO
        THE CLAIM.
      </Graf>
      <Graf>
        THE LIMITATIONS OF THIS SUBSECTION SHALL APPLY TO ANY THEORY OF
        LIABILITY, WHETHER BASED ON WARRANTY, CONTRACT, STATUTE, TORT (INCLUDING
        NEGLIGENCE) OR OTHERWISE, AND WHETHER OR NOT THE SAUCEY ENTITIES HAVE
        BEEN INFORMED OF THE POSSIBILITY OF ANY SUCH DAMAGE, AND EVEN IF A
        REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL
        PURPOSE. TO THE FULLEST EXTENT PERMITTED BY LAW.
      </Graf>

      <Subheading>XIII. Indemnity</Subheading>
      <Graf>
        You agree to defend, indemnify and hold harmless the Saucey Entities
        from and against any and all claims, damages, obligations, losses,
        liabilities, costs or debt, and expenses (including but not limited to
        attorney’s fees) arising from: (i) your use of and access to the
        Services; (ii) your violation of any term of these Terms; (iii) your
        violation of any third party right, including without limitation any
        copyright, property, or privacy right; or (iv) any claim that your use
        of the Services caused damage to a third party. This defense and
        indemnification obligation will survive these Terms and your use of the
        Services.
      </Graf>

      <Subheading>XIV. Waiver</Subheading>
      <Graf>
        Saucey’s failure to enforce any right or provision of these Terms shall
        not be deemed a waiver of such right or provision.
      </Graf>

      <Subheading>XV. Severability</Subheading>
      <Graf>
        In the event that any provision of these Terms is held to be void,
        invalid, unlawful or unenforceable, then that provision will be limited
        or eliminated to the minimum extent necessary, and the remaining
        provisions of these Terms will remain in full force and effect.
      </Graf>

      <Subheading>XVI. Headings and Construction</Subheading>
      <Graf>
        The section titles in the Terms are for your convenience only and carry
        no contractual or legal effect whatsoever. The language in these Terms
        shall be interpreted in accordance with its fair meaning and shall not
        be strictly interpreted for or against either party.
      </Graf>

      <Subheading>XVII. Controlling Law and Jurisdiction</Subheading>
      <Graf>
        The Terms and any action, claims, dispute related to the Terms will be
        governed by the laws of the State of California, including consumer,
        civil and criminal laws of the State of California, without regard or
        application of an conflicts of law provisions of your state or country
        of residence.
      </Graf>
      <Graf>
        You are agreeing to consent in advance to personal jurisdiction in the
        State of California. Saucey, Inc. is a California-registered corporation
        with its main headquarters in California. Any dispute that may arise in
        the future between yourself and Saucey, Inc. will be subject to the laws
        of California, including consumer, civil, and criminal law. If you do
        not agree with this forum selection, do not use or download Saucey,
        Inc.’s mobile application, website, or any other services.
      </Graf>
      <Graf>
        If you are a federal, state, or local government entity in the United
        States using the Services in your official capacity and legally unable
        to accept the controlling law, jurisdiction or venue clauses above, then
        those clauses do not apply to you. For such U.S. federal government
        entities, these Terms and any action related thereto will be governed by
        the laws of the United States of America (without reference to conflict
        of laws) and, in the absence of federal law and to the extent permitted
        under federal law, the laws of the State of California (excluding choice
        of law).
      </Graf>

      <Subheading>XVIII. Payment Methods</Subheading>
      <Graf>
        Saucey accepts Visa, MasterCard, Discover and American Express Credit
        Cards. No cash payment is accepted.
      </Graf>
      <Graf>
        Saucey, Inc.’s privacy policy is effective as of April 1, 2014.
      </Graf>
    </Article>
  );
}
